<div class="close-dialog-holder close-dialog-holder--with-title">
  <h2>
    {{
      'payment-details.component.payment_details_header'
        | localise: 'Payment Details'
    }}
  </h2>
  <button
    mat-icon-button
    mat-dialog-close
    type="button"
    class="close-dialog-button">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<mat-dialog-content class="payment-dialog__body">
  <strong>{{
    'payment-details.component.details' | localise: 'Details'
  }}</strong>
  @if (payment) {
    <ul class="payment-dialog__summary">
      <li>
        <span class="category">{{
          'payment-details.component.amount' | localise: 'Amount'
        }}</span>
        <span class="value">{{
          payment.total | currencyJs: { showSymbol: true }
        }}</span>
      </li>
      <li>
        <span class="category">{{
          'payment-details.component.source_account'
            | localise: 'Source account'
        }}</span>
        <span class="value"
          >{{ bank?.institution }}
          {{ bank?.accountNumber | removeSubstring: '*' }}
        </span>
      </li>
      <li>
        <span class="category">{{
          'payment-details.component.remaining_balance'
            | localise: 'Remaining Balance'
        }}</span>
        <span class="value">{{
          remainingBalance | currencyJs: { showSymbol: true }
        }}</span>
      </li>
      <li>
        <span class="category">{{
          'payment-details.component.status' | localise: 'Status'
        }}</span>
        <span class="value">{{
          promisedPaymentStatusNames[payment.status]
        }}</span>
      </li>
      <li>
        <span class="category">{{
          'payment-details.component.date_scheduled'
            | localise: 'Date Scheduled'
        }}</span>
        <span class="value">{{ payment.effectiveDate | dateApp }}</span>
      </li>
    </ul>
  }
  @if (payment.status === promisedPaymentStatusEnum.Scheduled) {
    <small>
      {{
        'payment-details.component.cant_reschedule_payment'
          | localise
            : 'Your payment cannot be rescheduled. If you want to make changes, Cancel this payment and then schedule a new payment from the dashboard.'
      }}
    </small>
  }
</mat-dialog-content>

<mat-dialog-actions class="payment-dialog__actions">
  @if (
    payment.status === promisedPaymentStatusEnum.Scheduled &&
    payment.createdByUserId
  ) {
    <button
      mat-button
      type="button"
      class="dialog-button"
      [disabled]="workloadIndicator.isLoading | async"
      (click)="cancelPayment()">
      @if (workloadIndicator.isNotLoading | async) {
        <span>{{
          'payment-details.component.cancel_payment_button'
            | localise: 'Cancel Payment'
        }}</span>
      }
      @if (workloadIndicator.isLoading | async) {
        <mat-spinner class="loader" [diameter]="25"></mat-spinner>
      }
    </button>
  }
</mat-dialog-actions>
